// GENERATED by scripts/gen-hooks.mjs. Do not edit by hand.
// 16 hooks for backend/platform.

import { useBackend } from '../useBackend'

/** POST /api/platform/acceptPlatformRequest */
export function useAcceptPlatformRequest<T = any>() {
  return useBackend<T>('platform/acceptPlatformRequest')
}

/** POST /api/platform/answerPlatformQuestion */
export function useAnswerPlatformQuestion<T = any>() {
  return useBackend<T>('platform/answerPlatformQuestion')
}

/** POST /api/platform/confirmPlatformTriage */
export function useConfirmPlatformTriage<T = any>() {
  return useBackend<T>('platform/confirmPlatformTriage')
}

/** POST /api/platform/createPlatformRequest */
export function useCreatePlatformRequest<T = any>() {
  return useBackend<T>('platform/createPlatformRequest')
}

/** POST /api/platform/declinePlatformRequest */
export function useDeclinePlatformRequest<T = any>() {
  return useBackend<T>('platform/declinePlatformRequest')
}

/** POST /api/platform/getPlatformAssetUrl */
export function useGetPlatformAssetUrl<T = any>() {
  return useBackend<T>('platform/getPlatformAssetUrl')
}

/** POST /api/platform/getPlatformBoard */
export function useGetPlatformBoard<T = any>() {
  return useBackend<T>('platform/getPlatformBoard')
}

/** POST /api/platform/getPlatformPipeline */
export function useGetPlatformPipeline<T = any>() {
  return useBackend<T>('platform/getPlatformPipeline')
}

/** POST /api/platform/getPlatformRequest */
export function useGetPlatformRequest<T = any>() {
  return useBackend<T>('platform/getPlatformRequest')
}

/** POST /api/platform/interpretPlatformRequest */
export function useInterpretPlatformRequest<T = any>() {
  return useBackend<T>('platform/interpretPlatformRequest')
}

/** POST /api/platform/recordPlatformAsset */
export function useRecordPlatformAsset<T = any>() {
  return useBackend<T>('platform/recordPlatformAsset')
}

/** POST /api/platform/resolvePlatformRequest */
export function useResolvePlatformRequest<T = any>() {
  return useBackend<T>('platform/resolvePlatformRequest')
}

/** POST /api/platform/savePlatformSlaBand */
export function useSavePlatformSlaBand<T = any>() {
  return useBackend<T>('platform/savePlatformSlaBand')
}

/** POST /api/platform/setPlatformRequestLinks */
export function useSetPlatformRequestLinks<T = any>() {
  return useBackend<T>('platform/setPlatformRequestLinks')
}

/** POST /api/platform/signPlatformUpload */
export function useSignPlatformUpload<T = any>() {
  return useBackend<T>('platform/signPlatformUpload')
}

/** POST /api/platform/updatePipelineItem */
export function useUpdatePipelineItem<T = any>() {
  return useBackend<T>('platform/updatePipelineItem')
}
